import type { DropdownProps } from "@circle-react-uikit/Dropdown";

import { SpaceGroupOptionsDropdownUIKitComponent } from "./SpaceGroupOptionsDropdownUIKitComponent";

export interface SpaceGroupOptionsDropdownProps extends DropdownProps {
  canManage?: boolean;
  onAddMembersClick?: () => void;
  onEditSpaceGroupClick?: () => void;
  onToggle: (isOpen: boolean) => void;
  seeMembersLink: string;
  seeSpacesLink: string;
}

export const SpaceGroupOptionsDropdown = ({
  canManage,
  onAddMembersClick,
  onEditSpaceGroupClick,
  onToggle,
  seeMembersLink,
  seeSpacesLink,
  ...rest
}: SpaceGroupOptionsDropdownProps) => (
  <SpaceGroupOptionsDropdownUIKitComponent
    canManage={canManage}
    onAddMembersClick={onAddMembersClick}
    onEditSpaceGroupClick={onEditSpaceGroupClick}
    onToggle={onToggle}
    seeMembersLink={seeMembersLink}
    seeSpacesLink={seeSpacesLink}
    {...rest}
  />
);
